import type { TreeDesignTokens } from '@primeuix/themes/types/tree';

/**
 * Tree component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tree/index.ts
 *
 * Component documentation:
 * https://primeng.org/tree
 */
export const treeComponentTokens: Partial<TreeDesignTokens> = {
  node: {
    padding: '0.75rem',
    borderRadius: '{navigation.item.borderRadius}',
    gap: '{navigation.item.gap}',
    hoverBackground: '{navigation.item.focusBackground}',
    selectedBackground: '{navigation.item.activeBackground}',
    color: '{navigation.item.color}',
    hoverColor: '{navigation.item.focusColor}',
    selectedColor: '{navigation.item.activeColor}',
  },
  nodeIcon: {
    color: '{navigation.submenuIcon.color}',
    hoverColor: '{navigation.submenuIcon.focusColor}',
    selectedColor: '{navigation.submenuIcon.activeColor}',
  },
  nodeToggleButton: {
    size: '1rem',
  },
};
